"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _utils = require("./utils");

var _createApi = require("./createApi");

var _default = function _default(store) {
  return function (next) {
    return function (action) {
      if (!action[_createApi.symbol]) {
        return next(action);
      }

      var requestData = action.requestData,
          types = action.types;
      var requestPayload = requestData.payload;
      next({
        type: types.request,
        payload: requestPayload
      });
      (0, _utils.fetchApi)(requestData, action.map, store.getState(), function (body, meta) {
        next({
          type: types.success,
          payload: {
            request: requestPayload,
            body: body,
            meta: meta
          }
        });
      }, function (message, body, meta) {
        next({
          type: types.failure,
          payload: {
            request: requestPayload,
            message: message,
            body: body,
            meta: meta
          }
        });
      });
    };
  };
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-server-middleware/lib/apiMiddleware.js
// module id = 1212
// module chunks = 0